export default __webpack_public_path__ + "static/media/dark_hackathon-calendar.991b33ae.svg";